import React, { useEffect, useState } from "react";
import { apiGet } from "../../../services/api";

interface AgeingRow {
  lab_id?: number;
  lab_name: string;
  ageing: { "0_30": number; "31_60": number; "61_plus": number };
  total_due: number;
}

export default function LabAgeing({ labId }: { labId?: string }) {
  const [rows, setRows] = useState<AgeingRow[]>([]);

  useEffect(() => {
    const query = labId ? `?lab_id=${labId}` : "";
    apiGet(`/api/manager/lab-ageing${query}`).then((data: unknown) => {
      const arr = Array.isArray(data) ? (data as AgeingRow[]) : [];
      setRows(arr);
    }).catch(() => setRows([]));
  }, [labId]);

  return (
    <div className="card">
      <h3>🧪 Lab Ageing</h3>

      <table className="records-table">
        <thead>
          <tr>
            <th>Lab</th>
            <th>0–30</th>
            <th>31–60</th>
            <th>61+</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.lab_id ?? i}>
              <td>{r.lab_name}</td>
              <td>₹{r.ageing["0_30"].toLocaleString("en-IN")}</td>
              <td>₹{r.ageing["31_60"].toLocaleString("en-IN")}</td>
              <td className="text-red">₹{r.ageing["61_plus"].toLocaleString("en-IN")}</td>
              <td><strong>₹{r.total_due.toLocaleString("en-IN")}</strong></td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td colSpan={5} className="muted">No lab ageing data.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
